import { forEach } from 'lodash';

export default {
  methods: {
    /**
     * We check each field to see if there is an options function
     * to retrieve the options (via ajax) for the filters
     * @returns {*}
     */
    runOptionsFn(force) {
      forEach(this.filters, async (field, key) => {
        if (field.optionsFn && (force || field.options.length === 0)) {
          this.filters[key].options = await field.optionsFn();
        }
      });
    },
  },
};
